import { useTranslation } from "react-i18next";
import { Text } from "@components/new/Typo";
import { Button, ButtonType, ButtonSize } from "@components/new/Button";
import { Loader } from "@components/Loader";
import styles from "./TopUp.module.scss";

interface TopUpProps {
  qrCode?: string;
  isProcessing?: boolean;
  isLoading?: boolean;
  error?: string;
  onRefresh: () => void;
}

const TopUp = ({ qrCode, isProcessing, isLoading, error, onRefresh }: TopUpProps) => {
  const { t } = useTranslation();
  const showLoader = isLoading || isProcessing || !qrCode;

  return (
    <div className={styles.body}>
      <div className={styles.card}>
        <div className={styles.qrGroup}>
          <div className={styles.qr}>
            {showLoader ? (
              <Loader alignment="center" size="xl" />
            ) : (
              <img
                className={styles.qrImg}
                alt="qrCode"
                src={`data:image/svg+xml;base64,${qrCode}`}
              />
            )}
          </div>
          <Text className={styles.hint}>{t("fbpPage.pickUp.topUpQrHint")}</Text>
        </div>

        {!isProcessing ? (
          <Button
            type={ButtonType.GHOST}
            size={ButtonSize.M}
            title={t("paymentModalWindow.buttonUpdate")}
            onClick={onRefresh}
            loading={isLoading}
          />
        ) : null}

        {error ? <Text color="error-sade">{error}</Text> : null}
      </div>
    </div>
  );
};

export default TopUp;
